import { compile } from 'mathjs';

export const flatToTree = (
  questions,
  parentQuestionId = null,
  nestingLevel = 0,
) => {

  return questions.length ? questions
    .map(q => ({
      conditions: (q.conditions || []).map(c => ({
        action: c.action,
        datasheetQuestionId: c.datasheetQuestionId,
        logicalOperator: c.logicalOperator,
        position: c.position,
        predicate: c.predicate,
        predicateAddition: c.predicateAddition,
        rangeEnd: c.rangeEnd,
        rangeStart: c.rangeStart,
        rowName: c.rowName,
        value: c.value,
      })),
      datasheetQuestionId: q.datasheetQuestionId,
      nestingLevel,
      position: q.position,
      validations: (q.validations || []).map(c => ({
        position: c.position,
        rule: c.rule,
        text: c.text,
      })),
      customQuestionNumber: q.customQuestionNumber,
    })) : [];
};

export const treeToFlat = questions => {
  return questions.sort((a, b) => a.position - b.position);
};

const getRuleVariables = rule => {
  const questions = rule.match(/Q([0-9]+)/g);
  const result = {
    this: 1,
    NULL: 1,
    attachments: 1,
    external_attachments: 1,
    regular_attachments: 1,
    count: 1,
    Count: 1,
  };

  (questions || []).forEach(question => {
    result[question] = 1;
  });

  return result;
};

const prepareRule = rule => {
  return rule.replace(/EXCLUSIVE\[([0-9]+,?)+\]/g, 'true');
};

export const getRuleError = rule => {
  try {
    const expression = compile(prepareRule(rule));
    expression.evaluate(getRuleVariables(rule));
  } catch (e) {
    return e.toString();
  }
  return null;
};

const getValidationVariable = (result) => {
  const resultType = (result.result || {}).type;
  const resultColumnName = (result.result || {}).columnName;
  const resultColumn = (result.result || {}).column;
  let resultValue = (result.result || {}).value;
  if (resultColumn !== undefined && resultColumnName === undefined) {
    resultValue = null;
  } else if (resultValue === undefined) {
    resultValue = null;
  } else if (resultValue === '') {
    resultValue = null;
  } else if (resultValue === null) {
    resultValue = null;
  } else if ((resultType === 'radioButton' || resultType === 'file') && resultValue.length === 0) {
    resultValue = null;
  } else if (resultType === 'checkbox' && !resultValue) {
    resultValue = null;
  } else if (!Number.isNaN(+resultValue)) {
    resultValue = +resultValue;
  }

  if (Array.isArray(resultValue) && (resultType === 'starRating')) {
    return resultValue.includes(null) ? null : resultValue.join(',');
  }

  if ((resultValue === null) && (resultType === 'table')) {
    const tableResult = ((result.result || {}).rows || []).map(row => {
      return (row || []).map(cell => getValidationVariable({ result: cell })).filter(c => c !== null);
    }).flat(1);
    resultValue = (tableResult.length > 0) ? tableResult.join(', ') : null;
  }

  return resultValue;
};

export const getValidationVariables = results => {
  const variables = {};

  results.forEach(result => {
    variables[`Q${result.datasheetQuestionId}`] = getValidationVariable(result);
    variables[`ATT${result.datasheetQuestionId}`] = ((result.attachments || []).length > 0) ? true : null;
    variables[`EXTATT${result.datasheetQuestionId}`] = ((result.externalAttachments || []).length > 0) ? true : null;
  });

  return variables;
};
